import { OAUTH_FAILURE_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[OAUTH_FAILURE_MODULE_ID]: {
		moduleType: 'modal',
	},
}
